import React, { Component, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import styles from "./modalConfirmWindow.module.scss";

class ModalConfirmWindow extends Component {
  render() {
    const { isOpen } = this.props;

    if (!isOpen) {
      return null;
    }

    const node = document.getElementById("modalContainerId");
    if (!node) return null;

    return ReactDOM.createPortal(<div className={styles.modal}>{this.props.children}</div>, node);
  }
}

export default React.memo(ModalConfirmWindow);
